import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import cn from "clsx"

const buttonVariants = cva(
  "inline-flex relative justify-center focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "button primary-portal py-3!",
        defaultSmall:
          "button primary-portal py-2! px-4!",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "button outlined-black py-3!",
        outlineSmall:
          "button outlined-black py-2! px-4!",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        bumpCollective:
          "button bump-collective",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-charcoal text-sm border-b border-b-charcoal !p-0 !rounded-none tracking-wider uppercase font-semibold",
        sale: "button primary-portal !w-auto !py-3 !bg-coral-pop border !border-coral-pop hover:!text-coral-pop hover:!bg-transparent text-white",
        darksale: "button !py-3 bg-white text-[#F9986F] hover:bg-white/90",
        custom: "button",
      },
      size: {
        default: "px-4 py-2",
        sm: "px-0! text-tiny!",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
